module.exports = __webpack_public_path__ + "static/media/32.09075eb8.jpg";